import { ReactElement, useMemo } from 'react';
import { Button, useMediaQuery } from '@mui/material';

import { InfoCellContent } from 'modules/common/components/InfoCellContent';
import { Table } from 'modules/common/components/Table';
import { ShareIcon } from 'modules/common/icons';
import { Tokens } from 'modules/defi/components/Tokens/Tokens';
import { IDeFiItem } from 'modules/defi/types';
import { useGlobalTranslation } from 'modules/i18n';

import { translation } from '../DeFiTable/translation';
import { useStyles } from './useStyles';

interface IDeFiTableRowProps {
  data: IDeFiItem;
}

export function DeFiTableRow({ data }: IDeFiTableRowProps): ReactElement {
  const { t, keys } = useGlobalTranslation(translation);
  const { classes, theme } = useStyles();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const labels = useMemo(() => [data.protocolType], [data.protocolType]);

  return (
    <Table.Row className={classes.root}>
      <Table.Cell className={classes.tokensCell}>
        <Tokens tokens={data.tokens} />
      </Table.Cell>

      <Table.Cell mdLabel={t(keys.protocol)}>
        <InfoCellContent
          align={isMd ? 'right' : 'left'}
          icon={data.protocolIcon}
          iconClassName={classes.infoIcon}
          labels={labels}
          name={data.protocol}
        />
      </Table.Cell>

      <Table.Cell mdLabel={t(keys.network)}>
        <InfoCellContent
          align={isMd ? 'right' : 'left'}
          icon={data.networkIcon}
          iconClassName={classes.infoIcon}
          name={data.network}
        />
      </Table.Cell>

      <Table.Cell align="right">
        <Button className={classes.button} color="secondary" variant="outlined">
          <span>{t(keys.common.explore)}</span>

          <ShareIcon />
        </Button>
      </Table.Cell>
    </Table.Row>
  );
}
